import { ShieldCheck, Lock, UserCheck, FileLock2 } from "lucide-react";
import { AppLayout } from "@/components/AppLayout";
import { useAuth } from "@/context/AuthContext";

export default function Seguridad() {
  const { user } = useAuth();
  const items = [
    { icon: Lock, t: "Acceso autenticado", d: "El acceso a la plataforma requiere autenticación. Las sesiones son temporales y protegidas." },
    { icon: UserCheck, t: "Aislamiento por despacho", d: "Cada despacho accede únicamente a sus propios asuntos y documentos. No es posible acceder a expedientes de otros despachos." },
    { icon: FileLock2, t: "Documentación privada", d: "La documentación del litigio se almacena de forma privada, sin enlaces públicos permanentes. El acceso a los archivos se verifica en cada descarga." },
    { icon: ShieldCheck, t: "Entrega privada y control humano", d: "La Hoja de Pronóstico se entrega dentro de la plataforma, nunca por correo. Cada análisis del piloto incorpora control humano antes de su entrega." },
  ];
  return (
    <AppLayout variant={user?.role === "admin" ? "admin" : "firm"}>
      <div className="ddp-fade">
        <h1 className="ddp-serif" style={{ fontSize: "clamp(28px,4vw,40px)", color: "var(--burgundy-dark)", margin: 0, letterSpacing: "-.02em" }}>Seguridad</h1>
        <p style={{ color: "var(--muted)", fontSize: 15, marginTop: 8, maxWidth: 560, lineHeight: 1.6 }}>
          Cómo se protege la información del litigio en el piloto DDP.
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 16, marginTop: 28 }}>
        {items.map((it) => (
          <div key={it.t} className="ddp-card" style={{ padding: 24, display: "flex", gap: 16, alignItems: "flex-start" }}>
            <div style={{ background: "var(--surface)", color: "var(--burgundy)", borderRadius: 8, padding: 12, flexShrink: 0 }}><it.icon size={20} /></div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{it.t}</div>
              <p style={{ fontSize: 14, color: "var(--muted)", margin: "6px 0 0", lineHeight: 1.55 }}>{it.d}</p>
            </div>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
